import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { Redirect } from 'react-router-dom';

import Button from 'components/Button';
import PageTitle from 'components/PageTitle';
import Avatar from 'components/Avatar';

import containerActions from 'pages/Login/actions';

import { numberMask } from 'utilz';
import { URLS } from 'config';

import './styles.scss';

// !Object.keys(user).length ?
// <Redirect to={URLS.LOGIN} /> :
class Returned extends React.Component {
  state = {
    isOpenConfirm: false
  }
  toggleConfirmation = () => {
    this.setState(({ isOpenConfirm }) => ({
      isOpenConfirm: !isOpenConfirm
    }));
  }
  removeUserHandl = (e) => {
    e.preventDefault();

    this.props.removeUser();
  }

  render() {
    return (
      <div className="page-returned -not-full">
        <div className="returned-header">
          <Avatar />
          <PageTitle>
            {
              this.props.user.userName || this.props.user.name || this.props.name ? 'You are logged in as' : 'Complete registration'
            }
          </PageTitle>
          <PageTitle>
            {this.props.user.userName || this.props.user.name || this.props.name || ''}
          </PageTitle>
          {
            this.props.user.telephoneNumber ? (
              <p className="returned-description">
                +1 {numberMask(this.props.user.telephoneNumber)}
              </p>
            ) : null
          }
        </div>
        <Button
          onClick={(e) => {
            e.preventDefault();
            const lastRoute = localStorage.getItem('carsapp-route');
            const localStorageData = localStorage.getItem('carsapp') ? JSON.parse(localStorage.getItem('carsapp')) : null;

            if (localStorageData
              && localStorageData.user
              && localStorageData.user.user) {
                if (localStorageData.user.user.registrationDone) {
                  this.props.history.replace(URLS.PROFILECARS);

                  return;
                }
              this.props.getUserProgress((lastRouteServer) => {
                this.props.history.replace(lastRouteServer);
              });
          } else {
            this.props.history.replace(lastRoute || URLS.BASE);
          }
          }}
          disabled={false}
        >
            Continue where you left
        </Button>

        {
          !this.props.user.registrationDone ? (
            <button
              className="returned-button"
              onClick={(e) => {
                e.preventDefault();
                this.props.history.replace(URLS.BASE);

                this.props.resetStore();
              }}
            >
            Start from beginning
            </button>
            ) : null
          }
        <button className="button-logout -remove" onClick={this.toggleConfirmation}>
            Delete my profile
        </button>
        {
        this.state.isOpenConfirm ? (
          <div className={`confirmation-modal ${this.state.isOpenConfirm ? '-open' : ''}`}>
            <div className="confirmation-wrapper">
              <PageTitle>
          Delete your profile
              </PageTitle>
              <p className="confirmation-text">
        The profile will be permanently deleted.
              </p>

              <div className="confirmation-buttons">
                <button
                  onClick={this.toggleConfirmation}
                  className="confirmation-button -cancel"
                >
            Cancel
                </button>
                <button
                  onClick={this.removeUserHandl}
                  className="confirmation-button -delete"
                >
            Delete
                </button>
              </div>
            </div>
          </div>
        ) : <div />
      }
      </div>
    );
  }
}

Returned.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  resetStore: PropTypes.func.isRequired,
  removeUser: PropTypes.func.isRequired,
  // logout: PropTypes.func.isRequired,           <- ticket remove logout button https://app.asana.com/0/694466960478549/703894968284900
  getUserProgress: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  user: state.user.user,
  name: state.name.name
});


export default connect(mapStateToProps, containerActions)(Returned);



// WEBPACK FOOTER //
// ./src/pages/Returned/index.js